import { Route, useRouteMatch } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { MainCard } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/MainCard';
import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { TreeProgramTopHeader } from 'components/common';
import { CrossProgramRelationships } from 'components/widgets/CrossProgramRelationships/CrossProgramRelationships';
import { InputPrograms } from 'components/widgets/InputPrograms/InputPrograms';
import { VersionSummary } from 'components/widgets/VersionSummary/VersionSummary';

export const IntegratedProgramDetailsPage = () => {
    const { path } = useRouteMatch();
    useFullStoryPageView({ pageName: executionConfig.integratedProgramDetails.title });
    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader versionSelectorEnabled={false} showAll={true} isDisabled={true} />
                    </VersionSection>
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader
                        pageTitle={executionConfig.integratedProgramDetails.title}
                        showBack={true}
                        showBackLink={AppRoutes.buildPath(
                            AppRoutes.DASHBOARD_PLANNING_PATH,
                            executionConfig.programLibrary.link,
                        )}
                    />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <VersionSummary />
                <InputPrograms />
                <CrossProgramRelationships />
            </MainContent>
            <Route path={`${path}/card-:cardId`} render={() => <MainCard />} />
        </PageContainer>
    );
};
